<template>
  <div id="app">
    <b-card>
      <b-card-header>
        <b-card-title>Quotation Priority Analysis</b-card-title>
      </b-card-header>
      <apexchart
        type="bar"
        :height="chartOptions.chart.height"
        :options="chartOptions"
        :series="series"
      />
    </b-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { BCard, BCardTitle, BCardHeader } from "bootstrap-vue";

export default {
  name: "QuotationPriorityAnalysis",
  components: {
    apexchart: VueApexCharts,
    BCard,
    BCardHeader,
    BCardTitle,
  },
  data() {
    return {
      series: [
        {
          name: "High Priority",
          data: [4, 3, 5, 2, 1], // Example high priority counts for each quotation
        },
        {
          name: "Medium Priority",
          data: [6, 8, 4, 5, 3], // Example medium priority counts for each quotation
        },
        {
          name: "Low Priority",
          data: [2, 4, 3, 6, 7], // Example low priority counts for each quotation
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "bar",
          stacked: true, // Enables stacked bar chart
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#d9534f", "#f0ad4e", "#b0cc48"], // Red for High, Orange for Medium, Blue for Low
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"],
            opacity: 0.5,
          },
        },
        xaxis: {
          categories: [
            "Quote A",
            "Quote B",
            "Quote C",
            "Quote D",
            "Quote E", // Quotation IDs or names
          ],
          title: {
            text: "Quotation IDs",
          },
        },
        yaxis: {
          title: {
            text: "Count",
          },
        },
        tooltip: {
          theme: "dark",
          y: {
            formatter: function (val) {
              return `${val} quotations`;
            },
          },
        },
        legend: {
          position: "top",
        },
      },
    };
  },
};
</script>

<style scoped>
#app {
  width: 100%;
  height: 100%;
  margin: 20px;
}

@media (max-width: 768px) {
  #app {
    margin: 10px;
  }
}
</style>
